import { render, staticRenderFns } from "./InvoicesDetail.vue?vue&type=template&id=2deba286&"
import script from "./InvoicesDetail.vue?vue&type=script&lang=js&"
export * from "./InvoicesDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports